import { render, staticRenderFns } from "./priceDialog.vue?vue&type=template&id=c1b4e542&scoped=true"
import script from "./priceDialog.vue?vue&type=script&lang=js"
export * from "./priceDialog.vue?vue&type=script&lang=js"
import style0 from "./priceDialog.vue?vue&type=style&index=0&id=c1b4e542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4e542",
  null
  
)

export default component.exports